import { NgModule } from '@angular/core';

import { BadgeDirective } from './directives';

@NgModule({
    declarations: [
        BadgeDirective,
    ],
    exports: [
        BadgeDirective,
    ],
})

export class BadgeModule {}
